<script>
  import BrandLayout from '../components/Layout'
  import ListVideo from '@components/List/Video'
  import setWindowHistory from "@utils/window-history";
  import MobileBrandPageTitle from "@components/List/MobileBrandPageTitle";
  import { brandComputed } from '@store/helpers'

  const DEFAULT_SEARCH = {
    month: '',
    query: ''
  };

  export default {
    page() {
      return {
        title: `${this.currentBrand.title}`,
      }
    }, 
    components: {
      BrandLayout,
      ListVideo,
      MobileBrandPageTitle,
      ViedoItem: () => import("@components/List/NewsItem"),
    },
    props: {
      currentList: {
        type: Array,
        default: () => {
          return []
        },
      },
      featured: {
        type: Array,
        default: () => {
          return []
        },
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      }
    },
    data() {
      return {
        searchData: {
          month: this.$route.query.month || DEFAULT_SEARCH.month,
          query: this.$route.query.query || DEFAULT_SEARCH.query,
        },
        searchList: [
          {
            width: '20%',
            type: 'month',
            placeholder: '不限時間',
            name: 'month',
          },
          {
            type: 'text',
            placeholder: '請輸入關鍵字',
            name: 'query',
          },
        ],
        videoList: this.currentList || [],
        videoPagination: this.pagination || {},
        loadingFetchVideoList: false,
        isShowFilterMenu: false,
      }
    },
    computed: {
      ...brandComputed,
      formattedVideoList() {
        const list = this.videoList.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          brands: item.brands[0],
          to: {
            name: 'brand-video-item',
            params: {
              brandAlias: this.$route.query.brand || item.brands[0] && item.brands[0].alias,
              categoryAlias: item.category_alias,
              videoAlias: item.alias,
            },
          },
          videoId: this.youtubeId(item.extrafields.youtube_url.value)
        }))
        return list
      },
      formattedFeaturedList() {
        const list = this.featured.filter((item) => {
          return item.brands[0].alias === this.$route.params.brandAlias
        })
        return list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          brands: item.brands[0],
          top: true,
          to: {
            name: 'brand-video-item',
            params: {
              brandAlias: this.$route.query.brand || item.brands[0] && item.brands[0].alias,
              categoryAlias: item.category_alias,
              videoAlias: item.alias,
            },
          },
          videoId: this.formattedVideoId(item.extrafields.youtube_url.value)
        }))
      },
      hasFilter() {
        if(Object.keys(this.$route.query).length) {
          return Object.keys(this.$route.query)
            .some((key) => {
              return this.$route.query[key] !== undefined
            })
        } else {
          return false
        }
      },
    },
    created() {
      
    },
    methods: {
      onSubmit(data) {
        setWindowHistory({
          query: {
            // ...this.$route.query,
            page: 1
          }
        });
        this.tryToFetchVideoList({

          storeParams: {
            // ...this.$route.params,
            page: 1
          }
        })
      },
      onChangePagination(page) {
        this.tryToFetchVideoList({
          storeParams: {
            // ...this.$route.params,
            page
          }
        }).then(() => {
            const url = new URL(window.location)
            let params = url.searchParams;
            if(params.has('page')) {
              this.$scrollToElement({
                $el: this.$refs['sectionList'].$el,
                offset: 270,
              });
            }
        })
      },
      youtubeId(id) {

        if(id) {
          const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          const match = id.match(regExp);
          return (match && match[7].length === 11)
            ? match[7]
            : false;
        }

        return '';
      },
      formattedVideoId(id) {
        if(id.includes('=')){
          return id.split('=')[1]
        } else {
          return id.split('/')[id.split('/').length - 1]
        }
      },
      async tryToFetchVideoList({ storeParams } = {}) {
        this.loadingFetchVideoList = true;
        const params = {
          brand_alias: [this.$route.params.brandAlias],
          search_date: this.searchData.month,
          search: this.searchData.query,
          page: this.$route.query.page,
          limit: 9,
          ...storeParams
        }
        await this.$store.dispatch('article/fetchList', {
          contentAlias: 'video',
          params
        })
          .then((response) => {
            this.videoList = response.items;
            this.videoPagination = response.pagination;
          })
          .finally(() => {
            this.loadingFetchVideoList = false;
          })
      },
      onClearSearch() {
        Object.keys(this.searchData)
          .forEach(key => {
            this.searchData[key] = undefined
          });

        setWindowHistory({
          query: {
            ...this.$route.query,
            ...this.searchData,
            page: 1
          }
        });
        this.tryToFetchVideoList({
          storeParams: {
            page: 1
          }
        });
      },
      filterFeaturedList(list) {
        // const vm = this;
        return list.filter((item) => {
          return item.brands[0].alias === this.$route.params.brandAlias
          // if(item.brands[0].alias === this.$route.brandAlias) vm.list.push(item)
        })
      },
      onShowFilterMenu(status) {
        this.isShowFilterMenu = status
      },
      goToView(item) {
        this.$router.push(item.to)
      }
    }
  }
</script>
<template>
  <BrandLayout>
    <section :class="$style.sectionVideoList" class="section ">
      <div class="container">
        <BaseSectionTitle 
          title="產品影片" 
          class="text-center d-md-block d-none"
        />
        <MobileBrandPageTitle
          title="產品影片"
          class="d-md-none mt-md-4 mt-5"
          @openFilter="onShowFilterMenu(!isShowFilterMenu)"
        />
        <template v-if="hasFilter || currentList.length">
          <BaseSearchBar
            v-model="searchData"
            :list="searchList"
            :is-show-filter="isShowFilterMenu"
            submit-text="搜尋影片"
            class="isHasBrandMenu"
            @search="onSubmit"
            @openFilter="onShowFilterMenu(false)"
          />
          <div v-if="formattedFeaturedList.length" class="row">
            <div
              v-for="(item, $index2 ) in formattedFeaturedList"
              :key="$index2"
              class="col-12 featuredItem"
            >
              <ViedoItem
                is-row-item
                is-video
                :item="item"
                content-type="video"
                custom-class="item-hover-shadow"
                @goTo="goToView"
              />
            </div>
          </div>
          <template v-if="formattedVideoList.length">
            <ListVideo
              ref="sectionList"
              v-loading="loadingFetchVideoList"
              :list="formattedVideoList"
              type="grid"
              link-type="brand"
            />
            <BasePagination2
              :pagination="videoPagination"
              @change="onChangePagination"
            />
          </template>
          <BaseNull
            v-else
            is-search-null
            @clearSearch="onClearSearch"
          />
        </template>
        <BaseNull
          v-else
          content="<p class='my-0'>目前此頁面無資料</p> <p class='mb-0 mt-3'>點擊下方按鈕，探索更多資訊</p>"
        >
          <BaseButton
            :to="{
              name: 'brand-item',
              params: {
                brandAlias: $route.params.brandAlias,
              },
            }"
            class="isStylePrimary isCol4 isRadius mt-5">
            探索更多資訊
          </BaseButton>
        </BaseNull>
      </div>
    </section>
  </BrandLayout>
</template>

<style lang="scss" module>
  .sectionVideoList {
    // background-color: $color-gray-2;
    :global {
      .sectionVideoList {
      }

      .el-pagination.isStyleBase {
        padding-top: 2.5rem;
      }
      .featuredItem {
        margin-bottom: 2rem;
      }
    }
  }
</style>
